import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SideMenuItem from '@client/containers/sideMenu/sideMenuItem/SideMenuItem';
import ReactLink from '@client/components/reactLink/ReactLink';
import { ROUTES } from '@client/pages/routes';
import { strings } from '@client/localization/Localization';
import themeStyles from '@client/shared/styles/theme/theme-styles.scss';
import styles from './sideMenu.scss';

const menuItems = [
  {
    title: `${strings.home}`,
    route: '/',
    onlyMobile: true,
  },
  {
    title: `${strings.episodes}`,
    route: `${ROUTES.episodes}`,
    onlyMobile: true,
  },
  {
    title: `${strings.series}`,
    route: `${ROUTES.series}`,
    onlyMobile: true,
  },
  {
    title: `${strings.categories}`,
    onlyMobile: true,
  },
  {
    title: `${strings.collaborate}`,
    route: `${ROUTES.collaborate}`,
    onlyMobile: false,
  },
  {
    title: `${strings.aboutUs}`,
    route: `${ROUTES.about}`,
    onlyMobile: false,
  },
  {
    title: `${strings.contact}`,
    route: `${ROUTES.contact}`,
    onlyMobile: false,
  },
];

class SideMenu extends PureComponent {
  socialIcon = (link, src) => {
    if (!link) {
      return undefined;
    }
    return (
      <a target="_blank" rel="noopener noreferrer" href={link}>
        <img className={styles.socialIcon} src={src} alt={link} />
      </a>
    );
  };

  render() {
    const { className, onCloseClick, location, subEntries } = this.props;

    return (
      <div
        className={
          className ? `${styles.sideMenu} ${className}` : styles.sideMenu
        }
      >
        <div className={styles.exitIconBox} onClick={onCloseClick}>
          x
        </div>
        <div className={styles.menuContainer}>
          {menuItems.map((item, index) => {
            return (
              <SideMenuItem
                key={index}
                className={`${themeStyles.sideMenuItem}`}
                route={item.route}
                title={item.title}
                location={location}
                onCloseClick={onCloseClick}
                onlyMobile={item.onlyMobile}
                subEntries={subEntries}
              />
            );
          })}
          <div className={styles.menuSocial}>
            <div
              className={`${themeStyles.hideOnMobile} ${themeStyles.sideMenuItem}`}
            >
              {strings.follow}
            </div>
            <div className={styles.socialIcons}>
              <ReactLink to={'https://www.instagram.com/watchfactuals/?hl=en'}>
                <i
                  className={`icomoon icon-instagram-icon ${styles.socialIcon}`}
                  alt="factuals instagram"
                />
              </ReactLink>
              <ReactLink to={'https://www.facebook.com/FactualsCom/'}>
                <i
                  className={`icomoon icon-facebook-icon ${styles.socialIcon}`}
                  alt="factuals facebook"
                />
              </ReactLink>
              <ReactLink
                to={
                  'https://www.linkedin.com/company/factuals-nordic/?viewAsMember=true'
                }
              >
                <i
                  className={`icomoon icon-linkedin-icon ${styles.socialIcon}`}
                  alt="factuals linkedin"
                />
              </ReactLink>
              <ReactLink
                to={
                  'https://www.youtube.com/channel/UC3IVjalqPzQda3FOuSdGnSA?view_as=subscriber'
                }
              >
                <i
                  className={`icomoon icon-you-tube-icon ${styles.socialIcon}`}
                  alt="factuals youtube"
                />
              </ReactLink>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SideMenu.propTypes = {
  className: PropTypes.string,
  onCloseClick: PropTypes.func,
  location: PropTypes.object,
  subEntries: PropTypes.object,
};

export default SideMenu;
